module.exports = __webpack_public_path__ + "media/images/default/shared/header/nav-cover0-cea444da0d67147e83eaeb0482a9fa80.jpg";